import { createFileRoute, redirect } from '@tanstack/react-router';

import { CopyDevTokenPage } from '@frontend/features/auth/components/CopyDevTokenPage';
import { isLocalhost } from '@frontend/features/auth/util/util.auth.isLocalhost';
import { isProduction } from '@frontend/features/auth/util/util.auth.isProduction';

export const Route = createFileRoute('/copy-dev-token/')({
  component: CopyDevTokenPage,
  beforeLoad: () => {
    // Only allow access on dev environment
    // Redirect if on localhost or production
    if (isLocalhost() || isProduction()) {
      throw redirect({
        to: '/',
      });
    }
  },
});
